module.exports = __webpack_public_path__ + "img/avatar0.2bd76f01.png";